import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FaqService {
  subscriptions = new Subscription();

  constructor(
    private translate: TranslateService,
  ) { }

  public getFaqData() {
    const data = [
      {
        title: this.getSubscriptionResult(this.translate.get('what_is_magicbook.title')),
        content: [
          [
            {
              text: this.getSubscriptionResult(this.translate.get('what_is_magicbook.text1')),
            }
          ]
        ],
      },
      {
        title: this.getSubscriptionResult(this.translate.get('what_products_does_magicBook_offer.title')),
        content: [
          [
            {
              text: this.getSubscriptionResult(this.translate.get('what_products_does_magicBook_offer.text1')),
            }
          ]
        ],
      },
      {
        title: this.getSubscriptionResult(this.translate.get('how_much_does_a_photo_book_cost.title')),
        content: [
          [
            {
              text: this.getSubscriptionResult(this.translate.get('how_much_does_a_photo_book_cost.text1')),
            },
            { text: this.getSubscriptionResult(this.translate.get('how_much_does_a_photo_book_cost.text2')), href: '/product' }
          ]
        ],
      },
      {
        title: this.getSubscriptionResult(this.translate.get('how_can_i_specify_my_design_preferences.title')),
        content: [
          [
            {
              text: this.getSubscriptionResult(this.translate.get('how_can_i_specify_my_design_preferences.text1')),
            }
          ]
        ],
      },
      {
        title: this.getSubscriptionResult(this.translate.get('how_does_magicBook_work.title')),
        content: [
          [
            {
              text: this.getSubscriptionResult(this.translate.get('how_does_magicBook_work.text1')),
            }
          ],
          [
            {
              text: this.getSubscriptionResult(this.translate.get('how_does_magicBook_work.text2')),
            }
          ],
          [
            {
              text: this.getSubscriptionResult(this.translate.get('how_does_magicBook_work.text3')),
            }
          ],
          [
            {
              text: this.getSubscriptionResult(this.translate.get('how_does_magicBook_work.text4')),
            }
          ],
          [
            {
              text: this.getSubscriptionResult(this.translate.get('how_does_magicBook_work.text5')),
            },
            { text: this.getSubscriptionResult(this.translate.get('how_does_magicBook_work.text6')), href: '/how_it_works' }
          ],
        ]
      },
      {
        title: this.getSubscriptionResult(this.translate.get('why_should_i_choose_magicBook_over_other_solutions_on_the_market.title')),
        content: [
          [
            {
              text: this.getSubscriptionResult(
                this.translate.get('why_should_i_choose_magicBook_over_other_solutions_on_the_market.text1')
              ),
            }
          ]
        ],
      },
      {
        title: this.getSubscriptionResult(this.translate.get('how_long_does_it_take_for_magicbook_to_make_a_book.title')),
        content: [
          [
            {
              text: this.getSubscriptionResult(this.translate.get('how_long_does_it_take_for_magicbook_to_make_a_book.text1')),
            }
          ]
        ],
      },
      {
        title: this.getSubscriptionResult(this.translate.get('who_are_the_founders_of_magicbook.title')),
        content: [
          [
            {
              text: this.getSubscriptionResult(this.translate.get('who_are_the_founders_of_magicbook.text1')),
            }
          ],
          [
            {
              text: this.getSubscriptionResult(this.translate.get('who_are_the_founders_of_magicbook.text2')),
            }
          ],
          [
            {
              text: this.getSubscriptionResult(this.translate.get('who_are_the_founders_of_magicbook.text3')),
            }
          ],
          [
            {
              text: this.getSubscriptionResult(this.translate.get('who_are_the_founders_of_magicbook.text4')),
            }
          ]
        ],
      },
    ];
    return data;
  }

  getSubscriptionResult(observable: Observable<any>) {
    let result: string;
    this.subscriptions.add(
      observable.subscribe(res => {
      result = res;
    })
    );
    return result;
  }

  clearSubscriptions() {
    this.subscriptions.unsubscribe();
  }
}
